import { useCallback } from 'react'

export default function ColorPickerField({ label, value, onChange }) {
  const handleHexInput = useCallback((e) => {
    const val = e.target.value
    // Allow empty, partial, or full hex values while typing
    if (val === '' || /^#[0-9A-Fa-f]{0,6}$/.test(val)) {
      onChange(val)
    }
  }, [onChange])

  const handleColorInput = useCallback((e) => {
    onChange(e.target.value)
  }, [onChange])

  return (
    <div>
      <label className="block text-sm font-medium text-slate-700 mb-1.5">
        {label}
      </label>
      <div className="flex items-center space-x-3">
        <input
          type="color"
          value={value || '#000000'}
          onChange={handleColorInput}
          className="h-10 w-10 border border-slate-200 rounded-lg cursor-pointer p-0.5 bg-white"
        />
        <input
          type="text"
          value={value || ''}
          onChange={handleHexInput}
          className="w-28 px-3 py-2 border border-slate-200 rounded-xl text-sm font-mono focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all"
          maxLength={7}
          placeholder="#000000"
        />
        {value && (
          <div
            className="h-8 w-8 rounded-md border border-slate-200 flex-shrink-0"
            style={{ backgroundColor: value }}
          />
        )}
      </div>
    </div>
  )
}
